import {
  ProtocolWorkStreamFrame,
  ProtocolWorkStreamState,
} from '@core/interfaces/protocol-work-stream.interface';

/** Applies one ordered private stream; a gap requires a fresh subscription snapshot. */
export function applyProtocolWorkFrame(
  previous: ProtocolWorkStreamState | null,
  frame: ProtocolWorkStreamFrame,
): ProtocolWorkStreamState {
  if (
    frame.formatVersion !== 1 ||
    !['SNAPSHOT', 'DELTA'].includes(frame.kind) ||
    !frame.epoch ||
    !Number.isSafeInteger(frame.sequence) ||
    frame.sequence < 1
  )
    throw new Error('PROTOCOL_WORK_STREAM_ERROR');
  if (previous?.epoch === frame.epoch && frame.sequence <= previous.sequence)
    return previous;
  if (
    frame.kind === 'SNAPSHOT'
      ? frame.sequence !== 1
      : !previous ||
        frame.epoch !== previous.epoch ||
        frame.sequence !== previous.sequence + 1
  )
    throw new Error('PROTOCOL_WORK_SNAPSHOT_REQUIRED');
  if (
    !Array.isArray(frame.items) ||
    !Array.isArray(frame.removed) ||
    !Array.isArray(frame.order) ||
    !Array.isArray(frame.roles) ||
    !Number.isSafeInteger(frame.totalElements) ||
    frame.totalElements < 0 ||
    !Number.isSafeInteger(frame.count) ||
    frame.count < 0
  )
    throw new Error('PROTOCOL_WORK_STREAM_ERROR');
  const rows = new Map(
    (frame.kind === 'SNAPSHOT' ? [] : previous.items).map((row) => [
      row.id,
      row,
    ]),
  );
  for (const id of frame.removed) rows.delete(id);
  const changed = new Set<number>();
  for (const row of frame.items) {
    if (
      !row ||
      !Number.isSafeInteger(row.id) ||
      row.id <= 0 ||
      changed.has(row.id)
    )
      throw new Error('PROTOCOL_WORK_STREAM_ERROR');
    changed.add(row.id);
    rows.set(row.id, row);
  }
  if (
    new Set(frame.order).size !== frame.order.length ||
    frame.order.some((id) => !rows.has(id)) ||
    rows.size !== frame.order.length
  )
    throw new Error('PROTOCOL_WORK_STREAM_ERROR');
  return {
    epoch: frame.epoch,
    sequence: frame.sequence,
    items: frame.order.map((id) => rows.get(id)),
    totalElements: frame.totalElements,
    count: frame.count,
    roles: frame.roles,
  };
}
